import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/audiences/profile/loading';

export const Route = createFileRoute('/_private/settings/audiences/$id')({
  pendingComponent: Loading,
});
